import React, { useRef, useEffect } from 'react'

import './animation-rewards.scss'
import lottieJsonAnimation from './lottie-animation'

const previewAnim = 'animation/animation1/img_4.png'

function loadLottie() {
  if (window.lottie) {
    return Promise.resolve()
  }
  return new Promise(resolve => {
    var s = document.createElement('script')
    s.src = 'animation/lottie.min.js'
    s.async = true
    s.onload = function () {
      resolve()
    }
    setTimeout(() => {
      document.body.appendChild(s)
    }, 1000)
  })
}
const AnimationRewards = ({ className = '', type = 1 }) => {
  const isSSR = typeof window === 'undefined'
  const lottie_anim = useRef()
  const onLibLoad = () => {
    if (!isSSR && lottie_anim.current) {
      if (!window.lottie) {
        console.warn('%cRETRY LOAD LOTTIE...', 'font-size:16px;color:orange;')
        setTimeout(() => onLibLoad(), 100)
        return
      } 
      lottie_anim.current.innerHTML = ''
      window.lottie.loadAnimation({
        container: lottie_anim.current,
        loop: true,
        autoplay: true,
        animationData: lottieJsonAnimation[type],
      })
    }
  }
  useEffect(() => {
    loadLottie().then(onLibLoad)
  }, [lottie_anim])
  return (
    <div className={'f-animation-rewards ' + className}>
      <div ref={lottie_anim} className="lottie_anim__container">
        <img
          src={previewAnim}
          alt="cargando animacion de recompenza"
          title="recomepenzas"
          className="lottie_anim__preview_img"
          width="300px"
          height="256px"
        />
      </div>
    </div>
  )
}

export default AnimationRewards
